// Phase 2: Data Source Toggles Component
// Toggle Meta/Spotify/HypeDdit data sources

import React from 'react';
import type { ReportSources } from '../../../shared/types/reports';

interface DataSourceTogglesProps {
  value: ReportSources;
  onChange: (sources: ReportSources) => void;
}

const SOURCES = [
  { key: 'meta' as const, label: 'Meta Ads', color: 'blue', required: true },
  { key: 'spotify' as const, label: 'Spotify', color: 'green', required: true },
  { key: 'hypeddit' as const, label: 'HypeDdit', color: 'purple', required: false },
];

export const DataSourceToggles: React.FC<DataSourceTogglesProps> = ({ value, onChange }) => {
  const handleToggle = (key: keyof ReportSources) => {
    onChange({
      ...value,
      [key]: !value[key],
    });
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
        Data Sources
      </label>
      <div className="flex flex-wrap gap-2">
        {SOURCES.map((source) => {
          const isActive = value[source.key];
          
          return (
            <button
              key={source.key}
              onClick={() => !source.required && handleToggle(source.key)}
              disabled={source.required}
              className={`
                inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium
                transition-all duration-200 border
                ${isActive
                  ? `bg-${source.color}-100 dark:bg-${source.color}-900/20 
                     border-${source.color}-300 dark:border-${source.color}-700 
                     text-${source.color}-700 dark:text-${source.color}-300`
                  : 'bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400'
                }
                ${source.required 
                  ? 'cursor-not-allowed opacity-100' 
                  : 'cursor-pointer hover:opacity-80'
                }
              `}
              style={{
                backgroundColor: isActive 
                  ? source.color === 'blue' ? 'rgb(219 234 254)' 
                  : source.color === 'green' ? 'rgb(220 252 231)'
                  : 'rgb(243 232 255)'
                  : undefined,
                borderColor: isActive
                  ? source.color === 'blue' ? 'rgb(147 197 253)'
                  : source.color === 'green' ? 'rgb(134 239 172)'
                  : 'rgb(216 180 254)'
                  : undefined,
              }}
            >
              <div className={`h-2 w-2 rounded-full ${
                isActive ? 'bg-current' : 'bg-gray-400'
              }`} />
              <span>{source.label}</span>
              {source.required && (
                <span className="text-xs opacity-60">(required)</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
